import { Injectable } from '@angular/core';
import { IntegrationRuntime } from 'app/model/integrationRuntime/integrationRuntime';
import { ModelService } from 'app/model/services/model.service';
import { IntegrationRuntimeAdapters } from '../integrationruntime.adapter';
import { IntegrationRuntimeOperationsService } from 'app/apis/integration-runtime-operations-api.service';
import { irTypesConst } from 'app/integrationruntime/integrationruntime.constants';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { BehaviorSubject } from 'rxjs';
import { ModelStoreService } from 'app/services/model-store.service';
import { take } from 'rxjs/operators';
import ShellAPI from 'a365-shell-api';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';

@Injectable({
    providedIn: 'root'
})
export class IntegrationRuntimeVNetService {
    protected static readonly className = 'IntegrationRuntimeVNetService';

    public readonly interactiveStatusMap = new Map<IntegrationRuntime, BehaviorSubject<ShellAPI.integrationruntimeVnetApi.irInteractiveStatusType>>();

    public constructor(
        private readonly _modelService: ModelService,
        private readonly _modelStoreService: ModelStoreService,
        private readonly _irOperationService: IntegrationRuntimeOperationsService,
        private readonly _exposureControlService: ExposureControlService
    ) {
    }

    public async getVnetIRFromLinkedService(ls?: LinkedService): Promise<IntegrationRuntime> {
        try {
            if (ls == null) {
                return null;
            }
            await this._modelService.fetch(ls);
            if (ls.integrationRuntime == null) {
                return null;
            }
            await this._modelService.fetch(ls.integrationRuntime);
            const irType = IntegrationRuntimeAdapters.GetIRTypeFromLocalModel(ls.integrationRuntime);
            if (irType === irTypesConst.ManagedVNet) {
                return ls.integrationRuntime;
            }
            return null;
        } catch {
            return null;
        }
    }

    public async getDefaultVNetIR(): Promise<IntegrationRuntime> {
        const allIRs = await this._modelStoreService.integrationRuntime$.pipe(take(1)).toPromise();
        return allIRs.find((ir) => IntegrationRuntimeAdapters.isValidDefaultIR(ir, true));
    }

    public async getVNetIRDebugCapability(ir?: IntegrationRuntime): Promise<ShellAPI.integrationruntimeVnetApi.irInteractiveStatusType> {
        // invalid scenario
        if (!this._exposureControlService.isVNetPresent$.value || ir == null) {
            return 'Enabled';
        }
        try {
            await this._modelService.fetch(ir);
            const irType = IntegrationRuntimeAdapters.GetIRTypeFromLocalModel(ir);
            if (irType !== irTypesConst.ManagedVNet) {
                return 'Enabled';
            }
            const irStatus = await this._irOperationService.getStatusAsync(ir.name);
            return IntegrationRuntimeAdapters.GetInteractiveQueryStatus(irStatus.properties);
        } catch {
            return 'Disabled';
        }
    }

    public async checkVNetIRDebugCapability(ir?: IntegrationRuntime): Promise<boolean> {
        const irDebugStatus = await this.getVNetIRDebugCapability(ir);
        return irDebugStatus === 'Enabled';
    }
}
